import React from "react";

const Calender = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3333 1.99935H11.6666V0.666016H10.3333V1.99935H3.66659V0.666016H2.33325V1.99935H1.66659C0.933252 1.99935 0.333252 2.59935 0.333252 3.33268V13.9993C0.333252 14.7327 0.933252 15.3327 1.66659 15.3327H12.3333C13.0666 15.3327 13.6666 14.7327 13.6666 13.9993V3.33268C13.6666 2.59935 13.0666 1.99935 12.3333 1.99935ZM12.3333 13.9993H1.66659V5.33268H12.3333V13.9993Z"
        fill="#1A325D"
      />
    </svg>
  );
};

export default Calender;
